import React, { useRef } from 'react';
import styled from 'styled-components';
import { useOnClickOutside } from 'usehooks-ts';

import {
  Heart as HeartIcon,
  Burger as BurgerIcon,
  ArrowOnboarding as ArrowOnboardingIcon,
} from '@lt/components/icons-react/rebrand';
import { useTranslation } from '@lt/localization';

type Props = {
  isOnboardingShowed?: boolean;
  hideOnboarding: () => void;
  openSidebar: () => void;
  isShiftedWishlistOnboarding: boolean;
  isMobile: boolean;
};

const WishlistOnboarding = (props: Props) => {
  const {
    isOnboardingShowed,
    hideOnboarding,
    openSidebar,
    isShiftedWishlistOnboarding,
    isMobile,
  } = props;

  const { t } = useTranslation();
  const title = t('wishlist.title', { ns: 'wishlist' });
  const additionalText = t('wishlist.onboarding.text', { ns: 'wishlist' });
  const buttonText = t('wishlist.onboarding.great', { ns: 'wishlist' });

  const onClick = () => {
    hideOnboarding();
  };
  const onBurgerClicked = () => {
    hideOnboarding();
    openSidebar();
  };
  const onboardingRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(onboardingRef, hideOnboarding);
  if (!isOnboardingShowed || !isMobile) return null;
  return (
    <StyledContainer
      ref={onboardingRef}
      $isShifted={isShiftedWishlistOnboarding}
    >
      <StyledContent>
        <StyledBurgerIcon onClick={onBurgerClicked} />
        <StyledIconWithTitle>
          <StyledHeartIcon />
          {title}
        </StyledIconWithTitle>
        <StyledMoreText>{additionalText}</StyledMoreText>
        <StyledButton onClick={onClick}>{buttonText}</StyledButton>
        <StyledArrow />
      </StyledContent>
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $isShifted?: boolean }>`
  position: fixed;
  z-index: 1007; //выше сигареты
  top: ${({ $isShifted }) => ($isShifted ? `-60px` : `-120px`)};
  right: -156px;
  width: 379px;
  height: 379px;
  border-radius: 379px;
  background: var(--secondary);

  color: var(--white);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`;

const StyledContent = styled.div`
  position: relative;
  left: 66px;
  top: 158px;
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const StyledIconWithTitle = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
  margin-top: 26px;
`;

const StyledArrow = styled(ArrowOnboardingIcon)`
  top: 8px;
  position: absolute;
  width: 40px;
  height: 26px;
  right: 32px;
`;

const StyledBurgerIcon = styled(BurgerIcon)`
  height: 24px;
  path {
    fill: var(--white);
  }
`;

const StyledHeartIcon = styled(HeartIcon)`
  height: 16px;
  path {
    fill: var(--white);
  }
`;

const StyledMoreText = styled.div`
  margin-top: 8px;
  text-align: right;
`;

const StyledButton = styled.div`
  display: inline-flex;
  align-items: center;

  border-radius: var(--border-radius);
  background-color: var(--white);
  padding: 8px 12px;
  margin-top: 8px;

  color: var(--black);
`;

export default WishlistOnboarding;
